import gql from 'graphql-tag';

export const GET_APPLICATION = gql`
  query ($id: ID!, $applicantId: String!) {
    programmeChoiceMetadata {
      countryList {
        value
        label
      }
      universityList {
        label
        value
      }
    }

    application(id: $id) {
      applicationNo
      chiefSupervisor
      department
      applicant {
        _id
      }
      programmeChoice {
        _id
        entryYear
        studyMode
        department
        programme
        programmeType
        partner {
          university
          universityCategory
          proposedChiefSupervisor
          isPolyUHomeUniversity
          physicalLocation
        }
        researchArea
        researchAreaBackup
        proposedChiefSupervisor
        proposedChiefSupervisorBackup
        acceptNoResearchIndicator
      }
      hkpfsInformation {
        isHKPFSApplicant
        HKPFSReferenceNumber
      }
      distinctiveScholarships {
        files {
          name
          id
          link
        }
        fundingSource
        reason
      }
      academicQualifications {
        _id
        presentIndicator
        gpaIndicator
        rankIndicator
        academicCredentialIndicator
        degreeCertIndicator
        from
        to
        studyMode
        institution {
          country
          name
        }
        instructionMedium
        otherInstructionMedium
        currentStudyYear
        studyField
        degreeLevel
        qualificationMeans
        programmeName
        qualificationStatus
        academicOnlineVerificationCode
        degreeOnlineVerificationCode
        expectUpdateDate
        awardDate
        awardClassification
        withdrawDate
        officialClassRanking
        outOfRank
        officialMark
        outOfGpa
        convertGPARuleId
        marks {
          course
          credit
          result
        }
        markConversion {
          convertedMark
          letterToGPARule {
            name
          }
          digitToLetterRule {
            name
          }
        }

        certificates {
          id
          link
          name
        }

        transcripts {
          id
          link
          name
        }

        markExplanations {
          id
          link
          name
        }

        classRankProofs {
          id
          link
          name
        }

        otherDocuments {
          id
          link
          name
        }
      }
      languageQualifications {
        needEnglishTest
        testType
        testDate
        expectedResultUpdateDate
        resultAnnouncedIndicator
        referenceNo
        result {
          resultReceiptDate
          listening
          reading
          writing
          speaking
          overall
        }
        supportingDocuments {
          id
          link
          name
        }
        _id
      }
      otherTests {
        _id
        testType
        testDate
        expectedResultUpdateDate
        resultAnnouncedIndicator
        result {
          resultReceiptDate
          totalScore
          totalPercentile
          quantitativeScore
          quantitativePercentile
          analyticalWritingScore
          analyticalWritingPercentile
          verbalScore
          verbalPercentile
          integratedReasoningScore
          integratedReasoningPercentile
          dataInsightsScore
          dataInsightsPercentile
        }
        referenceNo
        supportingDocuments {
          id
          link
          name
        }
      }
      publications {
        _id
        publicationType
        publicationAuthors
        publicationTitle
        publicationName
        applicantRole
        specificRole
        publicationStatus
        publicationDate
        issuePageArticelNo
        peerReviewedIndicator
        citationInfo
        publicationUrl
        supportingDocuments {
          id
          link
          name
        }
      }
      merits {
        _id
      }
      academicReferees {
        _id
      }
      researchExperiences {
        _id
      }
      employments {
        _id
      }
      professionalQualifications {
        _id
      }
      trainings {
        _id
      }
      activities {
        _id
      }
      additionalDocuments {
        _id
        documentType
        supportingDocuments {
          id
          link
          name
        }
      }
      status
      remarks {
        fromRole
        toRole
        remark
        createdAt
      }

      proofDocuments {
        documentType
        supportingDocuments {
          id
          name
        }
        _id
      }

      declaration {
        personalType
        confirmation
        informationAccuracy
        engagement
      }
    }

    meetCondition(applicationId: $applicantId) {
      status
      conditions {
        item
        passed
      }
    }
  }
`;
